import * as Yup from "yup";

export const validateEmail = (email: string | undefined) => {
  if (!email) {
    return false;
  }
  return Yup.string().email().isValidSync(email);
};

const RTwitterLink = /^https:\/\/twitter.com\/[^/]+\/status\/\d+/;

export const validateTwitterLink = (url: string | undefined) => {
  if (!url) {
    return false;
  }
  return RTwitterLink.test(url);
};

export const validateDiscordServerLink = (url: string | undefined) => {
  if (!url) {
    return false;
  }
  return (
    url.indexOf("https://discord.gg/") === 0 ||
    url.indexOf("https://discord.com/invite") === 0
  );
};

export const validateSendingMeSquadLink = (url: string | undefined) => {
  if (!url) {
    return false;
  }
  return url.indexOf("sending.me/share/?squad=") > 0;
};

export const validateDiscordChannelLink = (url: string | undefined) => {
  if (!url) {
    return false;
  }
  return url.indexOf("https://discord.com/channels") === 0;
};

const RTelegramGroupLink = /^https:\/\/t.me\/./;

export const validateTelegramGroupLink = (url: string | undefined) => {
  if (!url) {
    return false;
  }
  return RTelegramGroupLink.test(url);
};

const REGEX_ADDRESS = /^0x[A-F0-9]{40}$/i;

export const isValidAddress = (address: string) => REGEX_ADDRESS.test(address);
